// extracted by mini-css-extract-plugin
export const wrapper = "selfie-instructions-module--wrapper--FeTkH";
export const main = "selfie-instructions-module--main--2vnmW";
export const image = "selfie-instructions-module--image--29Bba";